import { Injectable, inject } from '@angular/core';
import { ActivatedRouteSnapshot, UrlTree } from '@angular/router';
import { PICFLOW_CONFIG } from '../../picflow-config';
import { GalleryService } from '../../services/gallery.service';
import { RedirectService } from '../../services/redirect.service';

@Injectable({
  providedIn: 'root',
})
export class LegacyGalleryEmbedRedirectGuard {
  private redirectService = inject(RedirectService);
  private galleryService = inject(GalleryService);
  private config = inject(PICFLOW_CONFIG);

  async canActivate(next: ActivatedRouteSnapshot): Promise<UrlTree | boolean> {
    try {
      const gallery = await this.galleryService.getPublicGalleryFromSnapshot(next, { ignore503Errors: true });
      if (!gallery) return true;
      let url = `${this.config.correctPicflowUrl}/legacy-embed/${gallery.id}`;
      const query = new URLSearchParams(next.queryParams).toString();
      if (query) url += `?${query}`;
      return this.redirectService.externalRedirectTo(url);
    } catch (err) {
      console.error(err);
      return true;
    }
  }
}
